import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createLanguage } from '@/apis/languages'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { CreateLanguageRequest, CreateLanguageResponse } from '@/types/apis/languages'

export const useCreateLanguage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateLanguageResponse>()

  const create = useCallback(
    async (request: CreateLanguageRequest) => {
      try {
        setLoading(true)
        const res = await createLanguage(request)
        setResponse(res)
        openNotification({ description: t('pages.languages.create.createSuccessfully') })
        navigate(routes.languages.path)
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createLanguage: create,
    response,
  }
}
